var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-photo.fa597f20.png","uri@2x": __webpack_public_path__ + "icon-photo.5cd0505d.png","uri@3x": __webpack_public_path__ + "icon-photo.5a3a1055.png",
    width: 44,
    height: 44
});